import React, { useEffect, useMemo, useRef } from 'react';

import { Content, Footer, Row, Title, Value } from './styled';

import { COLORS } from '../../../utils/theme/colors';
import {
  DataType,
  PaymentStatus,
  mascaraMoeda,
} from '../../organisms/FinancialTable/useFinancialTable';

interface FinancialFooterProps {
  rowsData: DataType[];
  setRowsData: React.Dispatch<React.SetStateAction<DataType[]>>;
  setFinancialFooterHeight: React.Dispatch<React.SetStateAction<number>>;
}

const FinancialFooter = ({
  rowsData,
  setRowsData,
  setFinancialFooterHeight,
}: FinancialFooterProps) => {
  const footerRef = useRef<HTMLDivElement | null>(null);

  const footerValues = useMemo(() => {
    const { approvedTotal, otherTotal } = rowsData.reduce(
      (totals, current) => {
        if (current.paymentStatus === PaymentStatus.APPROVED) {
          totals.approvedTotal += current.value;
        } else if (
          current.paymentStatus === PaymentStatus.IN_PROCESS ||
          current.paymentStatus === PaymentStatus.PENDING ||
          current.paymentStatus === PaymentStatus.REJECTED
        ) {
          totals.otherTotal += current.value;
        }
        return totals;
      },
      { approvedTotal: 0, otherTotal: 0 },
    );

    return {
      totalValue: rowsData.reduce((total, current) => total + current.value, 0),
      approvedTotal,
      otherTotal,
    };
  }, [rowsData]);

  useEffect(() => {
    const currentRef = footerRef.current;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setFinancialFooterHeight(entry.contentRect.height);
      }
    });

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [setFinancialFooterHeight]);

  return (
    <Footer ref={footerRef}>
      <Content>
        <a className='clear-selection' onClick={() => setRowsData([])}>
          Limpar seleção
        </a>
        <Row>
          <Title>Selecionados</Title>
          <Value>{rowsData.length} itens</Value>
        </Row>

        <Row>
          <Title>Valor total</Title>
          <Value>{mascaraMoeda(footerValues.totalValue.toFixed(2))}</Value>
        </Row>

        <Row>
          <Title>Transações pagas</Title>
          <Value color={COLORS.popular}>
            {mascaraMoeda(footerValues.approvedTotal.toFixed(2))}
          </Value>
        </Row>

        <Row>
          <Title>Transações pendentes</Title>
          <Value color={COLORS.carBrandUsage}>
            {mascaraMoeda(footerValues.otherTotal.toFixed(2))}
          </Value>
        </Row>
      </Content>
    </Footer>
  );
};

export default FinancialFooter;
